var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4046 8.13978C15.4046 12.3591 11.9841 15.7796 7.76478 15.7796C3.54544 15.7796 0.125 12.3591 0.125 8.13978C0.125 3.92044 3.54544 0.5 7.76478 0.5C11.9841 0.5 15.4046 3.92044 15.4046 8.13978ZM6.8811 12.185L12.5493 6.51676C12.7418 6.32429 12.7418 6.0122 12.5493 5.81972L11.8523 5.12269C11.6598 4.93018 11.3477 4.93018 11.1552 5.12269L6.53256 9.74531L4.37435 7.5871C4.18188 7.39463 3.86979 7.39463 3.67728 7.5871L2.98025 8.28414C2.78777 8.47661 2.78777 8.7887 2.98025 8.98118L6.18403 12.185C6.37653 12.3775 6.68859 12.3775 6.8811 12.185Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluated);
export default __webpack_public_path__ + "static/media/evaluated.5d50b17e56e4237944b0a63991c42489.svg";
export { ForwardRef as ReactComponent };